// Navigazione da tastiera dei gruppi con un solo elemento raggiungibile con Tab (toggle a segmenti, tab, menu):
// frecce, Home e End. Funzione pura: il componente decide cosa farne (scegliere, spostare il focus).

// Prossima posizione abilitata a partire da `da`, in avanti (+1) o indietro (-1), con giro completo; -1 se non ce n'è.
export function prossimaAbilitata(da: number, passo: 1 | -1, totale: number, abilitata: (i: number) => boolean): number {
  for (let k = 1; k <= totale; k++) {
    const i = (((da + passo * k) % totale) + totale) % totale;
    if (abilitata(i)) return i;
  }
  return -1;
}

// Posizione di destinazione per un tasto, `undefined` se il tasto non riguarda il gruppo.
export function destinazioneDaTasto(
  tasto: string,
  corrente: number,
  totale: number,
  abilitata: (i: number) => boolean,
): number | undefined {
  switch (tasto) {
    case "ArrowRight":
    case "ArrowDown":
      return prossimaAbilitata(corrente, 1, totale, abilitata);
    case "ArrowLeft":
    case "ArrowUp":
      return prossimaAbilitata(corrente, -1, totale, abilitata);
    case "Home":
      return prossimaAbilitata(-1, 1, totale, abilitata);
    case "End":
      return prossimaAbilitata(totale, -1, totale, abilitata);
    default:
      return undefined;
  }
}
